import {
    CompanyPartnersResponse,
    GetWarehouseProductsResponse,
    GetWarehouseRootCategoriesResponse,
    GetWarehouseSubcategoriesResponse,
    SolutionProductsResponse,
    UserType,
} from './dataTypes';

export const mockGetWarehouseRootCategoriesResponse: GetWarehouseRootCategoriesResponse =
    {
        categories: Array.from({length: 4}, (_, i) => ({
            id: i + 1,
            code: `root${i + 1}`,
            name: `Root Category ${i + 1}`,
            productsCount: 76,
            productsTotalCount: 76,
            categoriesCount: 10,
            categories: Array.from({length: 10}, (_, j) => ({
                id: j + 1 + 10 * (i + 1),
                code: `sub${j + 1 + 10 * (i + 1)}`,
                name: `Subcategory ${j + 1 + 10 * (i + 1)}`,
                productsCount: 76,
                productsTotalCount: 76,
                categoriesCount: 5,
            })),
        })),
    };

export const getMockGetWarehouseSubcategoriesResponse = (
    categoryId: number,
): GetWarehouseSubcategoriesResponse => {
    return {
        category: {
            id: categoryId,
            code: `sub${categoryId}`,
            name: `Subcategory ${categoryId}`,
            productsCount: 76,
            productsTotalCount: 76,
            categoriesCount: 10,
        },
        subcategories: Array.from({length: 10}, (_, i) => ({
            id: categoryId * 10 + i + 1,
            code: `sub${categoryId * 10 + i + 1}`,
            name: `Subcategory ${categoryId * 10 + i + 1}`,
            productsCount: 76,
            productsTotalCount: 76,
            categoriesCount: categoryId * 10 + i + 1 > 1000 ? 0 : 10,
        })),
    };
};

export const getMockGetWarehouseProductsResponse = ({
    categoryId,
    page,
    sortType,
}: {
    categoryId: number;
    page: number;
    sortType: string;
}): GetWarehouseProductsResponse => {
    return {
        category: {
            id: categoryId,
            code: `sub${categoryId}`,
            name: `Subcategory ${categoryId}`,
            productsCount: 100,
            productsTotalCount: 100,
            categoriesCount: 5,
        },
        products: Array.from({length: 10}, (_, i) => ({
            id: parseInt(`${categoryId}77${i + 1}${page}`),
            marking: `${parseInt(`${categoryId}77${i + 1}`)}`,
            picture: `https://cdn.klenmarket.ru/1359569301/hostcmsfiles/cache/upload/default_shop_item/8/4/4/item_8446/shop_items_catalog_image8446b3fcb097fab289c45c57f219c27d26d2.jpg`,
            url: `https://www.klenmarket.ru/shop/furniture/skladnaia-banketnaia-mebel/skl_stol/stol-plastikovyi-skladnoi-1204nm/`,
            name: `Product ${parseInt(`${categoryId}77${i + 1}`)} - ${page} - sort(${sortType})`,
            price: 10000 * i * 1,
            price_old: 10000 * i * 0.9,
            remains: Math.floor(Math.random() * 10),
            onTheWay: Math.floor(Math.random() * 10),
        })),
        pagination: {
            currentPage: page,
            totalPages: 10,
            totalItems: 100,
        },
    };
};

export const mockCompanyPartners: CompanyPartnersResponse = {
    partner_name: 'Старая мельница',
    counterparties: [
        {
            id: 123,
            type: UserType.Legal,
            name: 'ООО «Буханка»',
            balance: 1000,
            members: [
                {
                    id: 123,
                    name: 'Константин',
                    surname: 'Эвкалиптов',
                    phone: '+7 950 650 70 80',
                    email: 'k.evkaliptov@yandex.ru',
                },
                {
                    id: 2,
                    name: 'Иван',
                    surname: 'Эвкалиптов',
                    phone: '+7 950 650 70 80',
                    email: 'k.evkaliptov@yandex.ru',
                },
            ],
            // documents: [
            //     {
            //         id: '1',
            //         file_name: 'Реквизиты ООО Буханка.pdf',
            //         url: 'https://www.klenmarket.ru/static/km2/build/img/bannr/expanding-november/bg@2x.webp',
            //     },
            // ],
        },
        {
            id: 2,
            type: UserType.Legal,
            name: 'ООО «Хипстерский крендель»',
            balance: -123300,
            members: [
                {
                    id: 3,
                    name: 'Сергей',
                    surname: 'Эвкалиптов',
                    phone: '+7 950 650 70 80',
                    email: 'k.evkaliptov@yandex.ru',
                },
                {
                    id: 4,
                    name: 'Владислав',
                    surname: 'Эвкалиптов',
                    phone: '+7 950 650 70 80',
                    email: 'k.evkaliptov@yandex.ru',
                },
                {
                    id: 5,
                    name: 'Олег',
                    surname: 'Эвкалиптов',
                    phone: '+7 950 650 70 80',
                    email: 'k.evkaliptov@yandex.ru',
                },
            ],
            documents: [
                {
                    id: 2,
                    file_name: 'Реквизиты ООО «Хипстерский крендель».pdf',
                    url: 'https://www.klenmarket.ru/static/km2/build/img/bannr/expanding-november/bg@2x.webp',
                },
            ],
        },
        {
            id: 3,
            type: UserType.Legal,
            name: 'ООО «Хипстерский крендель»',
            members: [
                {
                    id: 3,
                    name: 'Сергей',
                    surname: 'Эвкалиптов',
                    phone: '+7 950 650 70 80',
                    email: 'k.evkaliptov@yandex.ru',
                },
                {
                    id: 4,
                    name: 'Владислав',
                    surname: 'Эвкалиптов',
                    phone: '+7 950 650 70 80',
                    email: 'k.evkaliptov@yandex.ru',
                },
                {
                    id: 5,
                    name: 'Ivan',
                    surname: 'Эвкалиптов',
                    phone: '+7 950 650 70 80',
                    email: 'k.evkaliptov@yandex.ru',
                },
            ],
            documents: [],
        },
    ],
};

export const productsItemsMock: SolutionProductsResponse = {
    error: '',
    data: {
        groups: [
            {
                parent_id: '2862',
                name: 'Барная стойка Квадра',
                goods: [
                    {
                        id: 788750,
                        title: '"Квадра" модуль стойки прямой с гостевой столешницей L=1004 мм',
                        link: '/shop/furniture/bar-counters/modular-counters-economy/barnaia-stoika-kvadra-gladkii-fasad/barnaia-stoika-kvadra/kvadra-modul-stoiki-priamoi-s-gostevoi-stoleshnitsei-l1000-mm/',
                        group_id: '22899',
                        article: 'цех5001/1',
                        preview:
                            'https://static.klenmarket.ru/1752819610/hostcmsfiles/cache/upload/default_shop_item/7/8/8/item_788750/shop_items_catalog_image7887505a8abe6c622a51e06346eab9518d9b9d.jpg',
                        image_large:
                            '/upload/shop_1/7/8/8/item_788750/shop_items_catalog_image788750.jpg',
                        images: [
                            '/upload/shop_1/7/8/8/item_788750/shop_items_catalog_image788750.jpg',
                            '/upload/shop_1/7/8/8/item_788750/shop_property_file_788750_979717.jpg',
                            '/upload/shop_1/7/8/8/item_788750/shop_property_file_788750_979718.jpg',
                            '/upload/shop_1/7/8/8/item_788750/shop_property_file_788750_979719.jpg',
                            '/upload/shop_1/7/8/8/item_788750/shop_property_file_788750_979720.jpg',
                            '/upload/shop_1/7/8/8/item_788750/shop_property_file_788750_979721.jpg',
                            '/upload/shop_1/7/8/8/item_788750/shop_property_file_788750_979722.jpg',
                            '/upload/shop_1/7/8/8/item_788750/shop_property_file_788750_979723.jpg',
                            '/upload/shop_1/7/8/8/item_788750/shop_property_file_788750_979724.jpg',
                            '/upload/shop_1/7/8/8/item_788750/shop_property_file_788750_979725.jpg',
                            '/upload/shop_1/7/8/8/item_788750/shop_property_file_788750_979726.jpg',
                            '/upload/shop_1/7/8/8/item_788750/shop_property_file_788750_979727.jpg',
                            '/upload/shop_1/7/8/8/item_788750/shop_property_file_788750_979728.jpg',
                            '/upload/shop_1/7/8/8/item_788750/shop_property_file_788750_979729.jpg',
                            '/upload/shop_1/7/8/8/item_788750/shop_property_file_788750_979730.jpg',
                            '/upload/shop_1/7/8/8/item_788750/shop_property_file_788750_979731.jpg',
                            '/upload/shop_1/7/8/8/item_788750/shop_property_file_788750_979732.jpg',
                            '/upload/shop_1/7/8/8/item_788750/shop_property_file_788750_979733.jpg',
                        ],
                        count: 1,
                        price: {
                            old: 21100,
                            current: 21100,
                        },
                        counter: {
                            min: 1,
                            addBy: 1,
                            readonly: false,
                        },
                        discount: true,
                        deleted: false,
                    },
                    {
                        id: 788751,
                        title: '"Квадра" модуль стойки прямой с гостевой столешницей L=504 мм',
                        link: '/shop/furniture/bar-counters/modular-counters-economy/barnaia-stoika-kvadra-gladkii-fasad/barnaia-stoika-kvadra/kvadra-modul-stoiki-priamoi-s-gostevoi-stoleshnitsei-l500-mm/',
                        group_id: '22899',
                        article: 'цех5001/2',
                        preview:
                            'https://static.klenmarket.ru/1752731399/hostcmsfiles/cache/upload/default_shop_item/7/8/8/item_788751/shop_items_catalog_image7887515b8e56c4853ea435a1a9ac3488840216.jpg',
                        image_large:
                            '/upload/shop_1/7/8/8/item_788751/shop_items_catalog_image788751.jpg',
                        images: [
                            '/upload/shop_1/7/8/8/item_788751/shop_items_catalog_image788751.jpg',
                            '/upload/shop_1/7/8/8/item_788751/shop_property_file_788751_979734.jpg',
                            '/upload/shop_1/7/8/8/item_788751/shop_property_file_788751_979735.jpg',
                            '/upload/shop_1/7/8/8/item_788751/shop_property_file_788751_979736.jpg',
                            '/upload/shop_1/7/8/8/item_788751/shop_property_file_788751_979737.jpg',
                            '/upload/shop_1/7/8/8/item_788751/shop_property_file_788751_979738.jpg',
                            '/upload/shop_1/7/8/8/item_788751/shop_property_file_788751_979739.jpg',
                            '/upload/shop_1/7/8/8/item_788751/shop_property_file_788751_979740.jpg',
                            '/upload/shop_1/7/8/8/item_788751/shop_property_file_788751_979741.jpg',
                            '/upload/shop_1/7/8/8/item_788751/shop_property_file_788751_979742.jpg',
                            '/upload/shop_1/7/8/8/item_788751/shop_property_file_788751_979743.jpg',
                            '/upload/shop_1/7/8/8/item_788751/shop_property_file_788751_979744.jpg',
                            '/upload/shop_1/7/8/8/item_788751/shop_property_file_788751_979745.jpg',
                            '/upload/shop_1/7/8/8/item_788751/shop_property_file_788751_979746.jpg',
                            '/upload/shop_1/7/8/8/item_788751/shop_property_file_788751_979747.jpg',
                            '/upload/shop_1/7/8/8/item_788751/shop_property_file_788751_979748.jpg',
                            '/upload/shop_1/7/8/8/item_788751/shop_property_file_788751_979749.jpg',
                            '/upload/shop_1/7/8/8/item_788751/shop_property_file_788751_979750.jpg',
                        ],
                        count: 1,
                        price: {
                            old: 13500,
                            current: 13500,
                        },
                        counter: {
                            min: 1,
                            addBy: 1,
                            readonly: false,
                        },
                        discount: true,
                        deleted: false,
                    },
                    {
                        id: 788752,
                        title: '"Квадра" модуль стойки прямой без гостевой столешницы L=1004 мм',
                        link: '/shop/furniture/bar-counters/modular-counters-economy/barnaia-stoika-kvadra-gladkii-fasad/barnaia-stoika-kvadra/kvadra-modul-stoiki-priamoi-bez-gostevoi-stoleshnitsy-l1000-mm/',
                        group_id: '22899',
                        article: 'цех5001/3',
                        preview:
                            'https://static.klenmarket.ru/1752731400/hostcmsfiles/cache/upload/default_shop_item/7/8/8/item_788752/shop_items_catalog_image78875251d68adcfc59cfe60c9d3329f6fabd93.jpg',
                        image_large:
                            '/upload/shop_1/7/8/8/item_788752/shop_items_catalog_image788752.jpg',
                        images: [
                            '/upload/shop_1/7/8/8/item_788752/shop_items_catalog_image788752.jpg',
                            '/upload/shop_1/7/8/8/item_788752/shop_property_file_788752_979751.jpg',
                            '/upload/shop_1/7/8/8/item_788752/shop_property_file_788752_979752.jpg',
                            '/upload/shop_1/7/8/8/item_788752/shop_property_file_788752_979753.jpg',
                            '/upload/shop_1/7/8/8/item_788752/shop_property_file_788752_979754.jpg',
                            '/upload/shop_1/7/8/8/item_788752/shop_property_file_788752_979755.jpg',
                        ],
                        count: 1,
                        price: {
                            old: 0,
                            current: 0,
                        },
                        counter: {
                            min: 1,
                            addBy: 1,
                            readonly: false,
                        },
                        discount: true,
                        deleted: false,
                    },
                    {
                        id: 788753,
                        title: '"Квадра" модуль стойки прямой без гостевой столешницы L=504 мм',
                        link: '/shop/furniture/bar-counters/modular-counters-economy/barnaia-stoika-kvadra-gladkii-fasad/barnaia-stoika-kvadra/kvadra-modul-stoiki-priamoi-bez-gostevoi-stoleshnitsy-l500-mm/',
                        group_id: '22899',
                        article: 'цех5001/4',
                        preview:
                            'https://static.klenmarket.ru/1752731400/hostcmsfiles/cache/upload/default_shop_item/7/8/8/item_788753/shop_items_catalog_image788753b1a35317462035a95751960f737133c0.jpg',
                        image_large:
                            '/upload/shop_1/7/8/8/item_788753/shop_items_catalog_image788753.jpg',
                        images: [
                            '/upload/shop_1/7/8/8/item_788753/shop_items_catalog_image788753.jpg',
                            '/upload/shop_1/7/8/8/item_788753/shop_property_file_788753_979756.jpg',
                            '/upload/shop_1/7/8/8/item_788753/shop_property_file_788753_979757.jpg',
                            '/upload/shop_1/7/8/8/item_788753/shop_property_file_788753_979758.jpg',
                            '/upload/shop_1/7/8/8/item_788753/shop_property_file_788753_979759.jpg',
                            '/upload/shop_1/7/8/8/item_788753/shop_property_file_788753_979760.jpg',
                        ],
                        count: 1,
                        price: {
                            old: 11500,
                            current: 11500,
                        },
                        counter: {
                            min: 1,
                            addBy: 1,
                            readonly: false,
                        },
                        discount: true,
                        deleted: false,
                    },
                    {
                        id: 788754,
                        title: '"Квадра" угловой модуль стойки с внешним углом 90 град. L=1052 мм',
                        link: '/shop/furniture/bar-counters/modular-counters-economy/barnaia-stoika-kvadra-gladkii-fasad/barnaia-stoika-kvadra/kvadro-uglovoi-modul-stoiki-s-vneshnim-uglom-90-grad-l900-mm/',
                        group_id: '22899',
                        article: 'цех5001/5',
                        preview:
                            'https://static.klenmarket.ru/1752731401/hostcmsfiles/cache/upload/default_shop_item/7/8/8/item_788754/shop_items_catalog_image788754e4a8a8bcb994cb7b0fbd186b6061753f.jpg',
                        image_large:
                            '/upload/shop_1/7/8/8/item_788754/shop_items_catalog_image788754.jpg',
                        images: [
                            '/upload/shop_1/7/8/8/item_788754/shop_items_catalog_image788754.jpg',
                            '/upload/shop_1/7/8/8/item_788754/shop_property_file_788754_979761.jpg',
                            '/upload/shop_1/7/8/8/item_788754/shop_property_file_788754_979774.jpg',
                            '/upload/shop_1/7/8/8/item_788754/shop_property_file_788754_979775.jpg',
                            '/upload/shop_1/7/8/8/item_788754/shop_property_file_788754_979776.jpg',
                            '/upload/shop_1/7/8/8/item_788754/shop_property_file_788754_979769.jpg',
                            '/upload/shop_1/7/8/8/item_788754/shop_property_file_788754_979770.jpg',
                            '/upload/shop_1/7/8/8/item_788754/shop_property_file_788754_979762.jpg',
                            '/upload/shop_1/7/8/8/item_788754/shop_property_file_788754_979763.jpg',
                            '/upload/shop_1/7/8/8/item_788754/shop_property_file_788754_979764.jpg',
                            '/upload/shop_1/7/8/8/item_788754/shop_property_file_788754_979765.jpg',
                            '/upload/shop_1/7/8/8/item_788754/shop_property_file_788754_979766.jpg',
                            '/upload/shop_1/7/8/8/item_788754/shop_property_file_788754_979767.jpg',
                            '/upload/shop_1/7/8/8/item_788754/shop_property_file_788754_979768.jpg',
                            '/upload/shop_1/7/8/8/item_788754/shop_property_file_788754_979771.jpg',
                            '/upload/shop_1/7/8/8/item_788754/shop_property_file_788754_979772.jpg',
                            '/upload/shop_1/7/8/8/item_788754/shop_property_file_788754_979773.jpg',
                        ],
                        count: 1,
                        price: {
                            old: 26200,
                            current: 26200,
                        },
                        counter: {
                            min: 1,
                            addBy: 1,
                            readonly: false,
                        },
                        discount: true,
                        deleted: false,
                    },
                    {
                        id: 788755,
                        title: '"Квадра" угловой модуль стойки с внешним углом со скосом L=1000 мм',
                        link: '/shop/furniture/bar-counters/modular-counters-economy/barnaia-stoika-kvadra-gladkii-fasad/barnaia-stoika-kvadra/kvadro-uglovoi-modul-stoiki-s-vneshnim-uglom-so-skosom-l900-mm/',
                        group_id: '22899',
                        article: 'цех5001/6',
                        preview:
                            'https://static.klenmarket.ru/1752731402/hostcmsfiles/cache/upload/default_shop_item/7/8/8/item_788755/shop_items_catalog_image78875516f4c2902c755a24e77a5921fd34bcbd.jpg',
                        image_large:
                            '/upload/shop_1/7/8/8/item_788755/shop_items_catalog_image788755.jpg',
                        images: [
                            '/upload/shop_1/7/8/8/item_788755/shop_items_catalog_image788755.jpg',
                            '/upload/shop_1/7/8/8/item_788755/shop_property_file_788755_979777.jpg',
                            '/upload/shop_1/7/8/8/item_788755/shop_property_file_788755_979778.jpg',
                            '/upload/shop_1/7/8/8/item_788755/shop_property_file_788755_979779.jpg',
                            '/upload/shop_1/7/8/8/item_788755/shop_property_file_788755_979780.jpg',
                            '/upload/shop_1/7/8/8/item_788755/shop_property_file_788755_979781.jpg',
                        ],
                        count: 1,
                        price: {
                            old: 25600,
                            current: 25600,
                        },
                        counter: {
                            min: 1,
                            addBy: 1,
                            readonly: false,
                        },
                        discount: true,
                        deleted: false,
                    },
                    {
                        id: 788756,
                        title: '"Квадра" угловой модуль стойки с внутренним углом со скосом L=1000 мм',
                        link: '/shop/furniture/bar-counters/modular-counters-economy/barnaia-stoika-kvadra-gladkii-fasad/barnaia-stoika-kvadra/kvadro-uglovoi-modul-stoiki-s-vnutrennim-uglom-so-skosom-l900-mm/',
                        group_id: '22899',
                        article: 'цех5001/7',
                        preview:
                            'https://static.klenmarket.ru/1752731403/hostcmsfiles/cache/upload/default_shop_item/7/8/8/item_788756/shop_items_catalog_image788756eb6614fb935cda7d3beeacfbe2ed88d9.jpg',
                        image_large:
                            '/upload/shop_1/7/8/8/item_788756/shop_items_catalog_image788756.jpg',
                        images: [
                            '/upload/shop_1/7/8/8/item_788756/shop_items_catalog_image788756.jpg',
                            '/upload/shop_1/7/8/8/item_788756/shop_property_file_788756_979782.jpg',
                            '/upload/shop_1/7/8/8/item_788756/shop_property_file_788756_979783.jpg',
                            '/upload/shop_1/7/8/8/item_788756/shop_property_file_788756_979784.jpg',
                            '/upload/shop_1/7/8/8/item_788756/shop_property_file_788756_979785.jpg',
                            '/upload/shop_1/7/8/8/item_788756/shop_property_file_788756_979786.jpg',
                        ],
                        count: 1,
                        price: {
                            old: 26800,
                            current: 26800,
                        },
                        counter: {
                            min: 1,
                            addBy: 1,
                            readonly: false,
                        },
                        discount: true,
                        deleted: false,
                    },
                ],
                additionalGoods: [
                    {
                        id: 794624,
                        title: 'Пристенный модуль барной стойки с надстройкой L= 1004 мм без зеркала, со светодиодной лентой',
                        link: '/shop/furniture/bar-counters/modular-counters-economy/barnaia-stoika-ellegiia/barnaia-stoika-ellegiia/pristennyi-modul-barnoi-stoiki-s-nadstroikoi-l-1000-mm-bez-zerkala-so-svetodiodnoi-lentoi/',
                        group_id: '22887',
                        article: 'цех5000/6',
                        preview:
                            'https://static.klenmarket.ru/1752660233/hostcmsfiles/cache/upload/default_shop_item/7/8/9/item_789877/shop_items_catalog_image7898777fec7b8f63a39481a6425df1bb7e216b.jpg',
                        image_large:
                            '/upload/shop_1/7/8/9/item_789877/shop_items_catalog_image789877.jpg',
                        images: [
                            '/upload/shop_1/7/8/9/item_789877/shop_items_catalog_image789877.jpg',
                        ],
                        count: 1,
                        price: {
                            old: 31400,
                            current: 31400,
                        },
                        counter: {
                            min: 1,
                            addBy: 1,
                            readonly: false,
                        },
                        discount: true,
                        deleted: true,
                    },
                    {
                        id: 794619,
                        title: 'Пристенная тумба без надстройки с мойкой L=1004 мм',
                        link: '/shop/furniture/bar-counters/modular-counters-economy/barnaia-stoika-ellegiia/barnaia-stoika-ellegiia/pristennaia-tumba-bez-nadstroiki-s-moikoi-l1000-mm/',
                        group_id: '22887',
                        article: 'цех5000/1',
                        preview:
                            'https://static.klenmarket.ru/1752660205/hostcmsfiles/cache/upload/default_shop_item/7/8/9/item_789872/shop_items_catalog_image789872a04dc2f9a7fb63e6389686b6635089d2.jpg',
                        image_large:
                            '/upload/shop_1/7/8/9/item_789872/shop_items_catalog_image789872.jpg',
                        images: [
                            '/upload/shop_1/7/8/9/item_789872/shop_items_catalog_image789872.jpg',
                        ],
                        count: 1,
                        price: {
                            old: 22400,
                            current: 22400,
                        },
                        counter: {
                            min: 1,
                            addBy: 1,
                            readonly: false,
                        },
                        discount: true,
                        deleted: true,
                    },
                    {
                        id: 794620,
                        title: 'Пристенная тумба без надстройки без мойки L=1004 мм',
                        link: '/shop/furniture/bar-counters/modular-counters-economy/barnaia-stoika-ellegiia/barnaia-stoika-ellegiia/pristennaia-tumba-bez-nadstroiki-bez-moiki-l1000-mm/',
                        group_id: '22887',
                        article: 'цех5000/2',
                        preview:
                            'https://static.klenmarket.ru/1752660210/hostcmsfiles/cache/upload/default_shop_item/7/8/9/item_789873/shop_items_catalog_image78987368c469173bb410377112e3035167c2cb.jpg',
                        image_large:
                            '/upload/shop_1/7/8/9/item_789873/shop_items_catalog_image789873.jpg',
                        images: [
                            '/upload/shop_1/7/8/9/item_789873/shop_items_catalog_image789873.jpg',
                        ],
                        count: 1,
                        price: {
                            old: 16300,
                            current: 16300,
                        },
                        counter: {
                            min: 1,
                            addBy: 1,
                            readonly: false,
                        },
                        discount: true,
                        deleted: true,
                    },
                    {
                        id: 794621,
                        title: 'Пристенная тумба без надстройки с мойкой L=504 мм',
                        link: '/shop/furniture/bar-counters/modular-counters-economy/barnaia-stoika-ellegiia/barnaia-stoika-ellegiia/pristennaia-tumba-bez-nadstroiki-s-moikoi-l500-mm/',
                        group_id: '22887',
                        article: 'цех5000/3',
                        preview:
                            'https://static.klenmarket.ru/1752660217/hostcmsfiles/cache/upload/default_shop_item/7/8/9/item_789874/shop_items_catalog_image789874c432772f63244d3d9a4446a52ae73bba.jpg',
                        image_large:
                            '/upload/shop_1/7/8/9/item_789874/shop_items_catalog_image789874.jpg',
                        images: [
                            '/upload/shop_1/7/8/9/item_789874/shop_items_catalog_image789874.jpg',
                        ],
                        count: 1,
                        price: {
                            old: 17300,
                            current: 17300,
                        },
                        counter: {
                            min: 1,
                            addBy: 1,
                            readonly: false,
                        },
                        discount: true,
                        deleted: true,
                    },
                    {
                        id: 794622,
                        title: 'Пристенная тумба без надстройки без мойки L=504 мм',
                        link: '/shop/furniture/bar-counters/modular-counters-economy/barnaia-stoika-ellegiia/barnaia-stoika-ellegiia/pristennaia-tumba-bez-nadstroiki-bez-moiki-l500-mm/',
                        group_id: '22887',
                        article: 'цех5000/4',
                        preview:
                            'https://static.klenmarket.ru/1752660221/hostcmsfiles/cache/upload/default_shop_item/7/8/9/item_789875/shop_items_catalog_image7898755613c15f22462cf18f85f432028f32f1.jpg',
                        image_large:
                            '/upload/shop_1/7/8/9/item_789875/shop_items_catalog_image789875.jpg',
                        images: [
                            '/upload/shop_1/7/8/9/item_789875/shop_items_catalog_image789875.jpg',
                        ],
                        count: 1,
                        price: {
                            old: 10300,
                            current: 10300,
                        },
                        counter: {
                            min: 1,
                            addBy: 1,
                            readonly: false,
                        },
                        discount: true,
                        deleted: true,
                    },
                    {
                        id: 794623,
                        title: 'Пристенный модуль барной стойки с надстройкой L= 1004 мм с зеркалом, со светодиодной лентой',
                        link: '/shop/furniture/bar-counters/modular-counters-economy/barnaia-stoika-ellegiia/barnaia-stoika-ellegiia/pristennyi-modul-barnoi-stoiki-s-nadstroikoi-l-1000-mm-s-zerkalom-so-svetodiodnoi-lentoi/',
                        group_id: '22887',
                        article: 'цех5000/5',
                        preview:
                            'https://static.klenmarket.ru/1752660230/hostcmsfiles/cache/upload/default_shop_item/7/8/9/item_789876/shop_items_catalog_image789876c1083114a72b2b137a149c440777181e.jpg',
                        image_large:
                            '/upload/shop_1/7/8/9/item_789876/shop_items_catalog_image789876.jpg',
                        images: [
                            '/upload/shop_1/7/8/9/item_789876/shop_items_catalog_image789876.jpg',
                        ],
                        count: 1,
                        price: {
                            old: 39400,
                            current: 39400,
                        },
                        counter: {
                            min: 1,
                            addBy: 1,
                            readonly: false,
                        },
                        discount: true,
                        deleted: true,
                    },
                ],
            },
        ],
    },
} as SolutionProductsResponse;
